import React from 'react';
import { FormattedHTMLMessage } from 'component-utilities/intl';
import { PrimaryButton } from 'v-c/Buttons/Components';

interface ErrorRetryProps {
  onRetry?: () => void;
}

// Rendered by the loading-lifecycle boundaries (withJobsLoad for Exports/Audit
// Reports, the SavedSearchList proxy for Searches) when an initial data load
// fails. Previously a failed load fell through to a false empty table ("no
// requests for exports" / "Searches (0)"); this shows the failure honestly and
// offers an explicit retry so the user doesn't have to reload the page.
const ErrorRetry: React.FC<ErrorRetryProps> = ({ onRetry }) => (
  <div data-view="error-retry" style={{ textAlign: 'center', padding: '48px 16px' }}>
    <p>
      <FormattedHTMLMessage id="app.general.error_loading" />
    </p>
    {onRetry && (
      <div style={{ marginTop: '16px' }}>
        <PrimaryButton onClick={onRetry} data-action="retry">
          <FormattedHTMLMessage id="app.general.try_again" />
        </PrimaryButton>
      </div>
    )}
  </div>
);

export default ErrorRetry;
